<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>订单详情</h3>
                </el-col>
            </el-row>

            <div class="top-header">
                <p class="text-left" v-if="row.status >= 0">当前订单状态：
                    <span v-if="row.status === 0">待付款</span>
                    <span v-if="row.status === 1">待发货</span>
                    <span v-if="row.status === 2">交易关闭</span>
                    <span v-if="row.status === 3">待收货</span>
                    <span v-if="row.status === 4">待返还</span>
                    <span v-if="row.status === 5">待返还</span>
                    <span v-if="row.status === 6">待返还确认</span>
                    <span v-if="row.status === 7">已完成</span>
                    <span v-if="row.status === 8">退款中</span>
                    <span v-if="row.status === 9">已退款</span>
                    <span v-if="row.status === 98">已预约顺丰</span>
                    <span v-if="row.status === 99">完成中</span>
                    <span v-if="row.status === 100">已删除</span>
                </p>
                <el-select v-model="value" @change="controlChange" placeholder="更多操作">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                    </el-option>
                </el-select>
            </div>
            <div class="border">
                <h3>订单信息</h3>
                <el-form :model="row">
                    <el-form-item label="订单编号：" label-width="260px">
                        <span>{{row.orderNo}}</span>
                    </el-form-item>
                    <el-form-item label="下单时间：" label-width="260px">
                        <span v-if="row.created">{{ new Date(row.created).getFullYear()+'-'+(new Date(row.created).getMonth()+1)+'-'+new Date(row.created).getDate()+' '+new Date(row.created).getHours()+':'+new Date(row.created).getMinutes()+':'+new Date(row.created).getSeconds()}} </span>
                    </el-form-item>
                    <el-form-item label="付款时间：" label-width="260px">
                        <span v-if="row.status === 0 || row.status === 2 || row.status === 100"> 暂无 </span>
                        <span v-if="row.status !== 0 && row.status !== 2 && row.status !== 100 && row.rentOrders && row.rentOrders.length && row.rentOrders[0].payment">
                            {{ new Date(row.rentOrders[0].payment.updated).getFullYear()+'-'+(new Date(row.rentOrders[0].payment.updated).getMonth()+1)+'-'+new Date(row.rentOrders[0].payment.updated).getDate()+' '+new Date(row.rentOrders[0].payment.updated).getHours()+':'+new Date(row.rentOrders[0].payment.updated).getMinutes()+':'+new Date(row.rentOrders[0].payment.updated).getSeconds()}}
                        </span>
                    </el-form-item>
                    <el-form-item label="发货时间：" label-width="260px">
                        <div>
                            <span v-if="row.delivery && row.delivery.created">{{ new Date(row.delivery.created).getFullYear()+'-'+(new Date(row.delivery.created).getMonth()+1)+'-'+new Date(row.delivery.created).getDate()+' '+new Date(row.delivery.created).getHours()+':'+new Date(row.delivery.created).getMinutes()+':'+new Date(row.delivery.created).getSeconds()}} </span>
                            <span v-else>暂未发货</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="支付方式：" label-width="260px">
                        <span v-if="row.status !== 0 && row.status !== 2 && row.status !== 100 && row.rentOrders && row.rentOrders.length">{{row.isAlipayMini ? '支付宝支付' : '微信支付'}}</span>
                        <span v-else>暂未支付</span>
                        <!-- <span v-if="row.rentOrders && row.rentOrders.length">{{ row.rentOrders[0].payment.method}}</span> -->
                    </el-form-item>
                    <el-form-item label="支付流水号：" label-width="260px" v-if="!row.isAlipayMini">
                        <span v-if="row.status !== 0 && row.status !== 2 && row.status !== 100 && row.rentOrders && row.rentOrders.length && row.rentOrders[0].payment">{{ row.rentOrders[0].payment.tradeNo}}</span>
                        <span v-else>暂未支付</span>
                    </el-form-item>
                    <el-form-item label="" label-width="260px">
                        <el-tag type="primary" v-if="xuDay > 0">已续租{{xuDay}}天</el-tag>
                    </el-form-item>
                    <template v-if="row.isAlipayMini">
                        <el-form-item label="身份证号：" label-width="260px">
                            <span>{{row.certNo}}</span>
                        </el-form-item>
                        <el-form-item label="人脸识别：" label-width="260px">
                            <span>{{row.zmFace ? '通过' : '未通过'}}</span>
                        </el-form-item>
                        <!-- <el-form-item label="芝麻信用等级：" label-width="260px">
                            <span>{{row.zmGrade}}</span>
                        </el-form-item> -->
                        <el-form-item label="芝麻订单号：" label-width="260px">
                            <span>{{row.zmOrderNo}}</span>
                        </el-form-item>
                    </template>
                </el-form>
            </div>
            <div class="border">

                <h3>物流信息</h3>
                <el-form :model="row">
                    <el-form-item label="收件人：" label-width="260px">
                        <span>{{row.receiverName}}</span>
                    </el-form-item>
                    <el-form-item label="手机号：" label-width="260px">
                        <span>{{row.receiverTel}}</span>
                    </el-form-item>
                    <el-form-item label="地址：" label-width="260px">
                        <span v-if="row.addressDetail">{{row.addressDetail.province + ' ' + row.addressDetail.city + ' ' + row.addressDetail.district + ' ' + (row.addressDetail.detail || row.addressDetail.fullAddress)}}</span>
                    </el-form-item>
                    <el-form-item label="物流公司：" label-width="260px">
                        <div>
                            <span v-if="expressData && expressData.shipper">{{expressData.shipper === 'SELF' ? '自提' : expressData.shipper}}</span>
                            <span v-else>暂无</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="快递单号：" label-width="260px">
                        <span v-if="expressData && expressData.expressNum">{{expressData.expressNum}}</span>
                        <span v-else>暂无</span>
                        <el-button type="info" style="margin-left: 100px;" v-if="expressData && expressData.expressNum && expressData.shipper !== 'SELF'" @click="searchExpress">查物流</el-button>
                    </el-form-item>
                    <el-form-item label="发货人：" label-width="260px">
                        <span v-if="row.status === 0 || row.status === 2 || row.status === 100"> 暂无 </span>
                        <span v-else>{{ row.delivery && row.delivery.operator ? row.delivery.operator : '暂无'}}</span>
                    </el-form-item>
                </el-form>
            </div>
            <el-form>
                <el-form-item label="用户昵称：" label-width="260px">
                    <span>{{userInfo.nickName}}</span>
                </el-form-item>
                <el-form-item label="真实姓名：" label-width="260px">
                    <span>{{identityInfo ? identityInfo.zmName : ''}}</span>
                </el-form-item>
                <el-form-item label="手机号：" label-width="260px">
                    <span>{{((identityInfo && identityInfo.zmPhone) ? identityInfo.zmPhone : row.receiverTel) || ''}}</span>
                </el-form-item>
                <el-form-item label="租赁时间：" label-width="260px" v-if="row.dispalyExtra && row.dispalyExtra.tenancy.length">
                    <el-tag type="gray">{{fromatDate(row.dispalyExtra.tenancy[0].begin)}}</el-tag>
                    <span class="line"></span>
                    <el-tag type="danger">{{rentDay}}天</el-tag>
                    <span class="line"></span>
                    <el-tag type="gray" v-if="row && row.dispalyExtra && row.dispalyExtra.tenancy">{{fromatDate(row.dispalyExtra.tenancy[0].end)}}</el-tag>
                </el-form-item>
                <el-form-item label="租金(单位：元)：" label-width="260px" v-if="row.dispalyExtra">
                    <span>{{ (row.status ===0 ||row.status === 2) ? row.dispalyExtra.unpaidRentOrder.rental : row.dispalyExtra.paidData.rental }}</span>
                </el-form-item>
                <el-form-item label="优惠券抵扣(单位：元)：" label-width="260px" v-if="row.dispalyExtra">
                    <span>{{(row.status ===0 ||row.status === 2) ? row.dispalyExtra.unpaidRentOrder.discount : row.dispalyExtra.paidData.discount}}</span>
                </el-form-item>
                <el-form-item label="押金(单位：元)：" label-width="260px" v-if="row.dispalyExtra">
                    <span>{{(row.status ===0 ||row.status === 2) ? row.dispalyExtra.unpaidRentOrder.deposit : row.dispalyExtra.paidData.deposit }}</span>
                </el-form-item>
                <el-form-item label="减免押金(单位：元)：" label-width="260px" v-if="row.dispalyExtra">
                    <span>{{(row.status ===0 ||row.status === 2) ? row.dispalyExtra.unpaidRentOrder.depositDiscount : row.dispalyExtra.paidData.depositDiscount }}</span>
                </el-form-item>
                <el-form-item label="费用统计(单位：元)：" label-width="260px" v-if="row.dispalyExtra">
                    <span>{{(row.status ===0 ||row.status === 2) ? row.dispalyExtra.unpaidRentOrder.payMount : row.dispalyExtra.paymount }}</span>
                </el-form-item>
                <el-form-item label="费用统计(单位：元)：" label-width="260px" v-if="row.dispalyExtra">
                    <span>{{(row.status ===0 ||row.status === 2) ? row.dispalyExtra.unpaidRentOrder.payMount : row.dispalyExtra.paymount }}</span>
                </el-form-item>
                <template v-if="row.isAlipayMini">
                    <el-form-item label="支付宝小程序-芝麻信用免押金额(单位：元)：" label-width="300px" v-if="row.dispalyExtra">
                        <span>{{(row.dispalyExtra.unpaidRentOrder && row.dispalyExtra.unpaidRentOrder.creditAmount) || row.dispalyExtra.paidData.creditAmount}}</span>
                    </el-form-item>
                    <el-form-item label="支付宝小程序-冻结押金金额(单位：元)：" label-width="300px" v-if="row.dispalyExtra">
                        <span>{{(row.dispalyExtra.unpaidRentOrder && row.dispalyExtra.unpaidRentOrder.freezeAmount) || row.dispalyExtra.paidData.freezeAmount}}</span>
                    </el-form-item>
                    <el-form-item label="支付宝小程序-押金冻结方式：" label-width="300px" v-if="row.rentOrders.length && row.rentOrders[0].payment">
                        <span >{{{
                            'WITHHOLD': '代扣',
                            'PREAUTH': '预授权',
                            'ALL': '代扣&预授权'
                        }[row.rentOrders[0].payment.fundType]}}</span>
                    </el-form-item>
                    <el-form-item label="支付宝小程序-扣款记录：" v-if="row.status > 2 && row.status < 8" label-width="300px">
                        <el-table :data="row.dispalyExtra.paidData.installmentHistory">
                            <el-table-column prop="orderId" label="订单ID" width="80"/>
                            <el-table-column prop="orderNo" label="内部订单号" width="200"/>
                            <el-table-column prop="zmOrderNo" label="芝麻订单号" width="250"/>
                            <el-table-column prop="transNo" label="资金流水号" width="210"/>
                            <el-table-column prop="payAmount" label="金额(元)" width="90"/>
                            <el-table-column inline-template :context="_self" label="扣款类型">
                                <span :style="{'color': (row.isFinishLose ? '#F56C6C' : '#67C23A')}">{{row.isFinishLose ? '资损扣款' : '分期扣款'}}</span>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </template>
            </el-form>
            <div class="border">

                <el-table :data="row.orderItems">
                    <el-table-column prop="id" label="ID">
                    </el-table-column>
                    <el-table-column prop="name" label="商品名称">
                    </el-table-column>
                    <el-table-column prop="productCount" label="数量">
                    </el-table-column>
                    <el-table-column inline-template :context="_self" label="价格(元)">
                        <div>
                            <span>{{ row.unitPrice / 100 }}</span><span>{{ row.accessoryType === 2 ? '/天' : ''}}</span>
                        </div>
                    </el-table-column>
                    <el-table-column inline-template :context="_self" label="序列号">
                        <div>
                            <span v-if="status === 0 || status === 2 || status === 1 || status === 100 || status === 8 || status === 9"> 暂无 </span>
                            <p :key="i" v-for="i in row.deviceArr">{{i}}</p>
                        </div>

                    </el-table-column>
                    <el-table-column inline-template :context="_self" label="仓库">
                        <span v-if="status === 0 || status === 2 || status === 1 || status === 100 || status === 8 || status === 9"> 暂无 </span>
                        <span v-else>{{storageName}}</span>
                    </el-table-column>

                </el-table>
                <el-row :gutter="20">
                    <el-col :span="3" :offset="19">
                        <div style="margin-top: 20px">
                            <p v-if="row.dispalyExtra">实际支付：{{row.dispalyExtra.paidData.paymount}}</p>
                        </div>
                    </el-col>
                </el-row>

            </div>

            <div class="border">
                <h3>用户设备返还物流信息</h3>
                <el-form>
                    <el-form-item label="快递单号：" label-width="260px">
                        <span v-if="row && row.delivery && row.delivery.returnExpressNum">{{row.delivery.returnExpressNum}}</span>
                        <span v-if="row && row.delivery && !row.delivery.returnExpressNum">暂无</span>
                        <el-button type="info" style="margin-left: 100px;" v-if="row && row.delivery &&  row.delivery.returnExpressNum" @click="searchBackExpress">查物流</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="back">返回</el-button>
                </span>
        </div>

        <el-dialog title="物流信息" :visible.sync="dialogFormVisible" size="large">
            <el-form :model="form" v-loading="loading" element-loading-text="拼命加载中">
                <el-form-item label="快递单号：" label-width="260px">
                    <span>{{form.expressNum}}</span>
                </el-form-item>
                <el-form-item label="物流公司：" label-width="260px">
                    <!-- <span>{{form.shipper}}</span> -->
                    <span>顺丰</span>
                </el-form-item>
                <el-form-item label="状态：" label-width="260px" v-if="form.status">
                    <span v-if="form.status.State === '0'">无轨迹</span>
                    <span v-if="form.status.State === '1'">已揽收</span>
                    <span v-if="form.status.State === '2'">在途中</span>
                    <span v-if="form.status.State === '3'">签收</span>
                    <span v-if="form.status.State === '4'">问题件</span>
                    <span v-if="form.status.State === '201'">到达派件城市</span>
                </el-form-item>
                <el-form-item label="物流信息：" label-width="260px" v-if="form.status">
                    <el-form ref="form" :model="form" label-width="160px">
                        <el-form-item :label="item.AcceptTime" v-for="(item,index) in form.status.Traces" :key="index">
                            <span></span> <span>{{item.AcceptStation}}</span>
                        </el-form-item>
                    </el-form>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">关闭</el-button>
            </div>
        </el-dialog>

        <el-dialog title="确认返还" :visible.sync="dialogBack">
            <el-form :model="sureB">
                <el-form-item label="请输入返还的快递单号" label-width="200px">
                    <el-input v-model="sureB.name" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogBack = false">取 消</el-button>
                <el-button type="primary" @click="sureBackOrder">确认返还</el-button>
            </div>
        </el-dialog>

        <el-dialog title="更改返还快递单号" :visible.sync="dialogBacke">
            <el-form :model="sureB">
                <el-form-item label="返还的快递单号" label-width="200px">
                    <el-input v-model="sureB.name" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogBacke = false">取 消</el-button>
                <el-button type="primary" @click="sureBackOrdere">确认更改</el-button>
            </div>
        </el-dialog>

        <el-dialog title="更改物流信息" :visible.sync="dialogWu">
            <el-form :model="wuliu">
                <el-form-item label="请输入快递单号" label-width="150px">
                    <el-input v-model="wuliu.expressNum" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogWu = false">取 消</el-button>
                <el-button type="primary" @click="sureChangeW">确认更改</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import {
        getOrderId,
        getExpress,
        getUsersDetail,
        getExpressD,
        getStoragesId,
        deleteOrder,
        putExpress,
        cancelOrder,
        alipayMiniCancelOrder,
        backOrder,
        getProductsId,
        sendExpress,
        changeBackExpress,
        getUserIdentification
    } from '../../api/version'

    export default {
        data() {
            return {
                dialogWu: false,
                Role: sessionStorage.power,
                wuliu: {},
                row: {},
                sureB: {},
                dialogBack: false,
                dialogBacke: false,
                status: '',
                expressData: {},
                userInfo: {},
                rentDay: '',
                storageName: '',
                storageNo: '',
                dialogFormVisible: false,
                form: {},
                value: '',
                loading: true,
                xuDay: 0,
                options: [{
                    value: 'cancel',
                    label: '取消订单',
                    disabled: true
                }, {
                    value: 'change',
                    label: '更改物流信息',
                    disabled: true

                }, {
                    value: 'delete',
                    label: '删除订单',
                    disabled: true
                }, {
                    value: 'sure',
                    label: '确认收货',
                    disabled: true
                }, {
                    value: 'back',
                    label: '确认返还',
                    disabled: true
                }, {
                    value: 'backe',
                    label: '更改返还快递单号',
                    disabled: true
                }],
                identityInfo:null
            }
        },
        created() {

            getOrderId(sessionStorage.userId, this.$route.params.id).then(res => {
                
                this.row = res.data

                this.getIdentityInfo(this.row.userId)

                if (this.row.rentOrders.length > 1) {
                    let day = 0

                    this.row.rentOrders.forEach((item, index) => {
                        if (index > 0 && item.end && item.status !== 0) {
                            day += 1
                            day += parseInt((new Date(item.end) - new Date(item.begin)) / (1000 * 60 * 60 * 24))
                        }
                    })

                    this.xuDay = day
                }

                let ress = res.data
                this.status = res.data.status
                ress.orderItems.forEach((item, index) => {
                    if (item.insurance > 0) {
                        ress.orderItems.push({
                            id: '',
                            name: 'PlayCare',
                            productCount: 1,
                            unitPrice: item.insurance
                        })
                    }
                    if (item.productIds && item.productIds.length) {
                        ress.orderItems[index].deviceArr = []
                        item.productIds.forEach(item2 => {
                            getProductsId(sessionStorage.userId,item2).then(res => {
                                if (res.data) {

                                    ress.orderItems[index].deviceArr.push(res.data.deviceId)
                                    this.row = JSON.parse(JSON.stringify(ress))
                                    // console.log(this.row, 'ff')
                                }
                            })
                        })

                    }
                })
                if (this.row.status === 0) {
                    //待付款
                    this.options[0].disabled = false
                    if(this.Role === '1'){
                        this.options[2].disabled = false
                    }

                }

                if (this.row.status === 2 && this.Role === '1') {
                    //交易关闭
                    this.options[2].disabled = false
                }

                if (this.row.status === 3) {
                    //待收货
                    this.options[1].disabled = false
                    this.options[3].disabled = false
                }

                if (this.row.status === 4 || this.row.status === 5) {
                    //待返还
                    this.options[4].disabled = false
                     this.options[5].disabled = false
                }

                if (this.row.status === 6 || this.row.status === 7) {
                    this.options[5].disabled = false
                }


                getUsersDetail(sessionStorage.userId, res.data.userId).then(res => {
                    this.userInfo = res.data
                })
                if (res.data.storageId) {
                    getStoragesId(sessionStorage.userId, res.data.storageId).then(res => {
                        // console.log(res.data)
                        this.storageName = res.data.storageName
                        this.storageNo = res.data.storageNo
                    })
                }

                let day = ''

                if (res.data && res.data.dispalyExtra && res.data.dispalyExtra.tenancy.length) {
                    // console.log(res.data.dispalyExtra.tenancy, 'f')

                    day = parseInt((new Date(res.data.dispalyExtra.tenancy[0].end) - new Date(res.data.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                    this.rentDay = day === 0 ? '1' : day + 1
                }


                if (res.data.delivery && res.data.delivery.sendShipper) {
                    let filter = {
                        'where': {
                            'expressNum': res.data.delivery.sendExpressNum,
                            'shipper': res.data.delivery.sendShipper
                        }
                    }

                    // console.log(filter)
                    getExpress(sessionStorage.userId, JSON.stringify(filter)).then(res => {
                        console.log(res.data, 'gg')
                        if(res.data.length === 0) {
                            console.log('fs')
                            this.expressData = {
                                shipper: 'SELF',
                                expressNum: filter.where.expressNum
                            }
                        }else{
                             this.expressData = res.data[0]
                        }


                    })
                }
            })
        },
        methods: {
            fromatDate(str) {
                function double(val) {
                    if (val > 9) {
                        return val;
                    }
                    return '0' + val;
                }

                const d = new Date(str);
                const year = d.getFullYear();
                const month = d.getMonth() + 1;
                const date = d.getDate();

                return double(year) + '-' + double(month) + '-' + double(date);
            },
            sureBackOrdere() {
                changeBackExpress(sessionStorage.userId, this.row.id, {
                    returnExpressNum: this.sureB.name,
                    returnShipper: this.row.delivery.reurnShipper
                }).then(res => {
                    console.log(res)
                    if (res.data) {
                        this.$message({
                            type: 'success',
                            message: '更改成功！'
                        });
                       this.dialogBacke = false
                       console.log(this.row,'fd')
                       this.row.delivery.returnExpressNum = this.sureB.name
                    }
                }, err => {
                    console.log(err.response.data.error)
                    this.$message.error(err.response.data.error.message)
                })
            },
            sureChangeW() {
                if (this.wuliu.expressNum) {
                    let products = []
                    this.row.orderItems.forEach(item => {
                        products.push({
                            orderItemId: item.id,
                            productIds: item.productIds
                        })
                    })
                    let data = {
                        expressNumber: this.wuliu.expressNum,
                        shipper: this.row.delivery.sendShipper,
                        id: this.$route.params.id,
                        products: products
                    }
                    sendExpress(sessionStorage.userId, this.$route.params.id, data).then(res => {
                        if (res.data) {
                            this.$message({
                                type: 'success',
                                message: '更改成功！'
                            });
                            this.dialogWu = false
                            history.go(-1)
                        }
                    })
                }
            },
            sureBackOrder() {
                backOrder(sessionStorage.userId, this.$route.params.id, {
                    type: 1,
                    data: {
                        expressNum: this.sureB.name,
                        shipper: 'xx'
                    }
                }).then(res => {
                    if (res.data) {
                        this.$message({
                            type: 'success',
                            message: '确认返还成功！'
                        });
                        this.dialogBack = false
                        history.go(-1)
                    }
                })
            },
            back() {
                history.go(-1)
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleDetailSuccess(res, file) {
                this.picArr.push({
                    imgUrl: `https://img.shareplay.cc/${res.key}`,
                    title: this.title

                })
            },
            //查物流
            searchExpress() {
                this.loading = true
                this.dialogFormVisible = true
                getExpressD(sessionStorage.userId, this.expressData.expressNum, this.expressData.shipper).then(res => {
                    // console.log(res.data)
                    this.loading = false
                    this.form = res.data.result
                })
            },
            searchBackExpress() {
                getExpressD(sessionStorage.userId, this.row.delivery.returnExpressNum, this.row.delivery.returnShipper).then(res => {
                    // console.log(res.data)
                    if (res.data) {
                        this.dialogFormVisible = true
                        this.loading = false
                        this.form = res.data.result
                    }

                })
            },
            handleError() {
                this.$message.error('请重新登录')
                this.$router.push('/login')
            },
            beforeDetailUpload() {

            },
            handleDetailRemove(file, fileList) {
                // console.log(file);
                console.log(fileList[0].response);
                let arr = []
                fileList.forEach(item => {
                    arr.push({
                        imgUrl: `https://img.shareplay.cc/${item.response.key}`,
                        title: this.title
                    })
                })
                this.picArr = arr
            },
            controlChange(val) {
                // console.log(val)
                if (val === 'delete') {
                    //删除订单
                    this.$confirm('此操作将删除该订单, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        deleteOrder(sessionStorage.userId, this.$route.params.id).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                history.go(-1)
                            }
                        })
                    }).catch(() => {
                        this.value = ''
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });

                }
                // console.log(val)
                //确认收货
                if (val === 'sure') {
                    this.$confirm('此操作将确认收货, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        putExpress(sessionStorage.userId, this.$route.params.id).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: 'success',
                                    message: '成功确认收货!'
                                });
                                history.go(-1)
                            }
                        })
                    }).catch(() => {
                        this.value = ''
                        this.$message({
                            type: 'info',
                            message: '已取消确认收货'
                        });
                    });
                }

                //取消订单
                if (val === 'cancel') {
                    this.$confirm('此操作将取消该订单, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let handler = cancelOrder;
                        if (this.row.isAlipayMini) {
                            handler = alipayMiniCancelOrder;
                        }

                        handler(sessionStorage.userId, this.$route.params.id).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: 'success',
                                    message: '取消订单成功'
                                });
                            }
                        })
                    }).catch(() => {
                        this.value = ''
                        this.$message({
                            type: 'info',
                            message: '已取消此操作'
                        });
                    });
                }

                //确认返还操作
                if (val === 'back') {
                    this.dialogBack = true
                }

                //更改返还快递单号
                if (val === 'backe') {
                    this.dialogBacke = true
                    this.sureB.name = this.row.delivery.returnExpressNum

                }

                if (val === 'change') {
                    this.dialogWu = true
                }
            },
            onSubmit() {

                if (this.type === 'pic') {
                    if (this.picArr.length) {
                        delete this.bannerForm.id
                        this.bannerForm.value.type = 'pic'
                        this.bannerForm.value.content = JSON.parse(JSON.stringify(this.picArr))
                        putBanner(sessionStorage.userId, 13, this.bannerForm).then(res => {
                            // console.log(res.data)
                            if (res.data) {
                                this.$message({
                                    message: '修改成功',
                                    type: 'success'
                                });
                            }
                        })
                    }
                } else if (this.type === 'video') {
                    this.bannerForm.value.type = 'video'
                    this.videoData = JSON.parse(JSON.stringify(this.bannerForm))
                    delete this.videoData.content
                    this.videoData.value.content = {
                        videoUrl: this.videoUrl,
                        title: this.title
                    }
                    delete this.videoData.id
                    putBanner(sessionStorage.userId, 13, this.videoData).then(res => {
                        // console.log(res.data)
                        if (res.data) {
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                        }
                    })
                }



            },
            getIdentityInfo(userId){
                getUserIdentification(sessionStorage.userId,userId).then(res => {
                    this.identityInfo = res.data
                })
            }
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }

    .top-header {
        overflow: hidden;
    }

    .top-header p.text-left {
        float: left;
    }

    .top-header .el-select {
        float: right;
    }

    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .border {
        border-bottom: 1px solid #000;
        padding-bottom: 10px;
        margin-bottom: 20px;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .line {
        display: inline-block;
        height: 1px;
        width: 20px;
        border-top: 1px solid #000;
        vertical-align: middle;
        margin: 0 10px;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// OrderDetail.vue?c0c8eb74